module.exports = __webpack_public_path__ + "static/img/CashTodayUpdateCenterOscuro.79b8795e.svg";